import React from 'react';
import './ToastNotification.css';

function ToastNotification({ message, onClick, onClose }) {
    return (
        <div className="toast-notification" onClick={onClick}>
            <div className="toast-content">
                <span className="toast-icon">🔔</span>
                <p className="toast-message">{message}</p>
            </div>
            <button
                className="toast-close"
                onClick={(e) => {
                    e.stopPropagation();
                    onClose();
                }}
            >
                &times;
            </button>
        </div>
    );
}

export default ToastNotification;
